module.exports = __webpack_public_path__ + "img/BR.ebbd2cb3.svg";